// src/utils/isFingerprintBrowser.ts

/**
 * 只判断是否疑似真实指纹浏览器
 * true：有强证据，高度怀疑指纹浏览器
 * false：普通浏览器、虚拟机、云浏览器、开发环境全部返回false
 * 规则：①命中私有全局标记  OR  至少2项风险同时出现
 */
export function isFingerprintBrowser(): boolean {
  const win = window as any;
  const isDev = import.meta.env.DEV;

  // ---------- 强证据1：指纹浏览器私有全局变量，命中直接true ----------
  if (win.__adspower || win.bitbrowser || win.dolphin || win.vmlogin || win.ziniao) {
    
    return true;
  }

  // 收集风险项，只记录，不单项就判定
  const riskItems: string[] = [];

  // ----------风险项1：原生API被篡改（生产环境才统计，开发环境devtools干扰忽略） ----------
  try {
    const rawToString = Object.prototype.toString;
    if (rawToString.toString() !== "[object Object]") {
      if (!isDev) {
        riskItems.push("api_hook");
      } else {
        
      }
    }
  } catch {
    if (!isDev) {
      riskItems.push("api_exception");
    }
  }

  // ----------风险项2：WebGL真正软件虚拟渲染器（排除Windows原生ANGLE） ----------
  try {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (gl) {
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (debugInfo) {
        const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || "";
        const lower = renderer.toLowerCase();
        // 只识别真正软件虚拟显卡，原生Windows ANGLE直接跳过
        if (/swiftshader|virtual|llvmpipe/i.test(lower)) {
          riskItems.push("webgl_virtual");
        }
      }
    }
  } catch {
    if (!isDev) {
      riskItems.push("webgl_exception");
    }
  }

  // ----------风险项3：navigator UA与platform严重矛盾（指纹浏览器伪造经常忘改platform） ----------
  const ua = navigator.userAgent;
  const uaWin = ua.includes("Windows");
  const uaMac = ua.includes("Mac OS");
  const plat = navigator.platform;
  if ((uaWin && plat.startsWith("Mac")) || (uaMac && plat.startsWith("Win"))) {
    riskItems.push("platform_conflict");
  }

  // =====================================
  // 核心规则：至少命中2条风险项，才判定疑似指纹浏览器
  // 只有1条风险：虚拟机、云浏览器等正常异常环境，直接返回false
  // =====================================
  const hitCount = riskItems.length;
  const result = hitCount >= 2;

  return result;
}